import { useActions } from 'components/contexts/event-page'
import {
  useStore as useFiltersStore,
  useActions as useFiltersActions,
} from 'components/contexts/event-page-filters'
import { SegmentedControl } from '~shared'
import { Item } from '~shared/Toggle'

export const VIP = 'vip'
export const TICKETS = 'tickets'

export const items: Array<Item> = [
  { label: 'Tickets', value: TICKETS },
  { label: 'VIP', value: VIP, icon: 'star-filled' },
]

const ToggleVip = () => {
  const { toggleVip } = useFiltersActions()
  const { vip } = useFiltersStore()

  const { onClose } = useActions()

  return (
    <SegmentedControl
      value={vip ? VIP : TICKETS}
      onChange={() => {
        onClose()
        toggleVip()
      }}
      items={items}
    />
  )
}

export default ToggleVip
